import {crossbarStore} from "@/stores/crossbar";
import {measurementStore} from "@/stores/measurement";
import {socketStore} from "@/stores/socket";

export default {
    data() {
        return {
            statusTimeout: 0
        };
    },

    destroyed() {
        clearTimeout(this.statusTimeout);
    },

    computed: {
        isInShop() {
            return crossbarStore().isInShop;
        },

        status() {
            return measurementStore().status;
        },

        socketConnected() {
            return socketStore().isConnected;
        },

        allCoconsDisconnected() {
            return !this.socketConnected || this.status.every(x => x.bed_service_connected === false);
        },

        cocons() {
            return Math.max(1, this.status.length);
        },

        isStatusKnown() {
            return this.status.length > 0;
        }
    },

    methods: {
        isCoconConnected(cocon) {
            if (this.status[cocon] === undefined) return false;

            return this.status[cocon].bed_service_connected !== false;
        },

        isMeasurementActive(appointment) {
            return appointment && this.status.some(x => x.appointment_id === appointment.id && x.movie_active);
        },

        updateInShop() {
            this.isInShop = crossbarStore().isInShop;
        }
    }
};